import { call, put, takeLatest } from 'redux-saga/effects'
import { handleApiErrors } from '../../../lib/api-errors'
import axiosApi from '../../../views/client/axiosClient'

import * as guestConstant from './constants'
import * as guestAction from './actions'
import { transfersFromCached } from '../../../lib/common'

function handleRequest(request) {
  return request
    .then(handleApiErrors)
    .then(function (response) {
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}
function handleFileRequest(request) {
  return request
    .then(function (response) {
      return {
        data: response.data
      };
    })
    .catch((error) => { throw error })
}
function nvkdRequestApi(formData) {
  const request = axiosApi().post(
    guestConstant.GUEST_REPORT_NVKD_API,
    formData
  )

  return handleRequest(request);
}
function* guestReportNvkdRequestFlow(action) {
  try {
    // grab the client from our action
    const { formData } = action
    const results = yield call(nvkdRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(guestAction.guestReportNvkdSuccess(results.data))

  } catch (error) {
    yield put(guestAction.guestReportNvkdError(error))
  }
}
function khRequestApi(formData) {
  const request = axiosApi().post(
    guestConstant.GUEST_REPORT_KH_API,
    formData
  )

  return handleRequest(request);
}
function* guestReportKhRequestFlow(action) {
  try {
    // grab the client from our action
    const { formData } = action
    const { data } = yield call(khRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(guestAction.guestReportKhSuccess(transfersFromCached(data)))

  } catch (error) {
    yield put(guestAction.guestReportKhError(error))
  }
}

function listRequestApi(formData) {
  const request = axiosApi().post(
    guestConstant.GUEST_REPORT_LIST_API,
    formData
  )

  return handleRequest(request);
}


function* guestReportListRequestFlow(action) {
  try {
    // grab the client from our action
    const { formData } = action
    const results = yield call(listRequestApi, formData)

    // dispatch the action with our widgets!
    yield put(guestAction.guestReportListSuccess(results.data))

  } catch (error) {
    yield put(guestAction.guestReportListError(error))
  }
}

function exportXlsRequestApi(formData) {
  const url = guestConstant.GUEST_REPORT_EXPORT_XLS_API + "?s=" + formData.store_id + "&st=" + formData.tu_ngay + "&ed=" + formData.den_ngay
    + "&ldh=" + formData.loaiDonHang + "&ql=" + formData.treeQL + "&kd=" + formData.listNvkd
    + "&kh=" + formData.listKH + "&nkh" + formData.listNhomKh + "&tt=" + formData.trangThai + "&kw=" + formData.keyword;
  const request = axiosApi().get(
    url,
    {
      responseType: 'blob'
    }
  );

  return handleFileRequest(request);
}
function* reportExportXlsRequestFlow(action) {
  const { formData, callback } = action
  try {
    // grab the client from our action
    const results = yield call(exportXlsRequestApi, formData)
    // dispatch the action with our widgets!
    yield put(guestAction.reportExportXlsSuccess(results.data))
    if (typeof callback == 'function') {
      yield call(callback, results.data);
    }
  } catch (error) {
    yield put(guestAction.reportExportXlsError(error))
  }
}
function* guestReportNhomKhRequestFlow({ payload, callback }) {
  try {
    // grab the client from our action
    const request = axiosApi().post(
      guestConstant.GUEST_REPORT_NHOMKH_API,
      payload
    )
    const results = yield call(handleRequest, request)
    // dispatch the action with our widgets!
    yield put(guestAction.guestReportNhomKhSuccess(results.data))
    if (typeof callback == 'function') {
      yield call(callback, results.data);
    }
  } catch (error) {
    yield put(guestAction.guestReportNhomKhError(error))
  }
}
function* guestReportKhByNhomRequestFlow({ payload, callback }) {
  try {
    // grab the client from our action
    const request = axiosApi().post(
      guestConstant.GUEST_REPORT_KH_BY_NHOM_API,
      payload
    )
    const results = yield call(handleRequest, request)
    // dispatch the action with our widgets!
    yield put(guestAction.guestReportKhByNhomSuccess(results.data))
    if (typeof callback == 'function') {
      yield call(callback, results.data);
    }
  } catch (error) {
    yield put(guestAction.guestReportKhByNhomError(error))
  }
}

function* guestReportWatcher() {
  yield [
    takeLatest(guestConstant.GUEST_REPORT_NVKD_REQUESTING, guestReportNvkdRequestFlow),
    takeLatest(guestConstant.GUEST_REPORT_KH_REQUESTING, guestReportKhRequestFlow),
    takeLatest(guestConstant.GUEST_REPORT_LIST_REQUESTING, guestReportListRequestFlow),
    takeLatest(guestConstant.GUEST_REPORT_EXPORT_XLS_REQUESTING, reportExportXlsRequestFlow),
    takeLatest(guestConstant.GUEST_REPORT_NHOMKH_REQUESTING, guestReportNhomKhRequestFlow),
    takeLatest(guestConstant.GUEST_REPORT_KH_BY_NHOM_REQUESTING, guestReportKhByNhomRequestFlow),
  ]
}

export default guestReportWatcher



// WEBPACK FOOTER //
// ./src/views/Reports/GuestReport/sagas.js